import React from 'react';

import { Space } from '@sravni/react-design-system';
import { Button } from '@sravni/react-design-system/lib/Button';
import { useIsMobile } from '@sravni/react-utils';

import { PRODUCT_LIST_ANCHOR } from '@src/constants/common';
import { scrollToElementById } from '@src/helpers/common';
import { MobileAppConvenienceBanner } from 'entities/FullDeal';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';
import { FULL_DEAL_MOBILE_APP_LINKS, FULL_DEAL_MOBILE_APP_SOURCE } from 'features/FullDeal/config';

interface Props {
  amount: number;
  term: number;
  isLandingPage: boolean;
}

export const FullDealGoogleOfferActions = ({ amount, term, isLandingPage }: Props) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Space direction="vertical" size={8}>
        <MobileAppConvenienceBanner
          amount={amount}
          term={term}
          isLandingPage={isLandingPage}
          variant="light"
          isUserFromGoogleSearch
        />

        <ToFullDealAdvertisingButton
          size={52}
          block
          variant="primary"
          link={FULL_DEAL_MOBILE_APP_LINKS.FROM_LANDING}
          color="blue"
          source={FULL_DEAL_MOBILE_APP_SOURCE.FROM_LANDING}
        >
          Подобрать займ в приложении
        </ToFullDealAdvertisingButton>

        <Button variant="text" size={52} block onClick={() => scrollToElementById(PRODUCT_LIST_ANCHOR)}>
          Продолжить на сайте
        </Button>
      </Space>
    );
  }

  return (
    <Button
      variant="primary"
      color="blue"
      size={60}
      block
      onClick={() => scrollToElementById(PRODUCT_LIST_ANCHOR)}
      style={{ width: 'fit-content' }}
    >
      Подобрать займ
    </Button>
  );
};
